import { render, staticRenderFns } from "./NavigationDrawerV2.vue?vue&type=template&id=7ab08d54&lang=pug"
import script from "./NavigationDrawerV2.vue?vue&type=script&lang=ts"
export * from "./NavigationDrawerV2.vue?vue&type=script&lang=ts"
import style0 from "./NavigationDrawerV2.vue?vue&type=style&index=0&id=7ab08d54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports